import { createSvgIcon } from '@mui/material';

const TotalAvailable = createSvgIcon(
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M20 7.49998L12 2.99998L4.00003 7.49998M20 7.49998V16.5L12 21M20 7.49998L12 12M12 21L4.00003 16.5V7.49998M12 21V12M4.00003 7.49998L12 12M16 5.24998L12 7.49998L8.00003 9.74998"
      stroke="black"
      strokeWidth="0.8"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M16 16.5C16 16.9596 16.0905 17.4148 16.2664 17.8394C16.4423 18.264 16.7001 18.6499 17.0251 18.9749C17.3501 19.2999 17.736 19.5577 18.1606 19.7336C18.5852 19.9095 19.0404 20 19.5 20C19.9596 20 20.4148 19.9095 20.8394 19.7336C21.264 19.5577 21.6499 19.2999 21.9749 18.9749C22.2999 18.6499 22.5577 18.264 22.7336 17.8394C22.9095 17.4148 23 16.9596 23 16.5C23 16.0404 22.9095 15.5852 22.7336 15.1606C22.5577 14.736 22.2999 14.3501 21.9749 14.0251C21.6499 13.7001 21.264 13.4423 20.8394 13.2664C20.4148 13.0905 19.9596 13 19.5 13C19.0404 13 18.5852 13.0905 18.1606 13.2664C17.736 13.4423 17.3501 13.7001 17.0251 14.0251C16.7001 14.3501 16.4423 14.736 16.2664 15.1606C16.0905 15.5852 16 16.0404 16 16.5Z"
      fill="white"
    />
    <path d="M18.3333 16.5L19.1111 17.2778L20.6667 15.7222" fill="white" />
    <path
      d="M18.3333 16.5L19.1111 17.2778L20.6667 15.7222M16 16.5C16 16.9596 16.0905 17.4148 16.2664 17.8394C16.4423 18.264 16.7001 18.6499 17.0251 18.9749C17.3501 19.2999 17.736 19.5577 18.1606 19.7336C18.5852 19.9095 19.0404 20 19.5 20C19.9596 20 20.4148 19.9095 20.8394 19.7336C21.264 19.5577 21.6499 19.2999 21.9749 18.9749C22.2999 18.6499 22.5577 18.264 22.7336 17.8394C22.9095 17.4148 23 16.9596 23 16.5C23 16.0404 22.9095 15.5852 22.7336 15.1606C22.5577 14.736 22.2999 14.3501 21.9749 14.0251C21.6499 13.7001 21.264 13.4423 20.8394 13.2664C20.4148 13.0905 19.9596 13 19.5 13C19.0404 13 18.5852 13.0905 18.1606 13.2664C17.736 13.4423 17.3501 13.7001 17.0251 14.0251C16.7001 14.3501 16.4423 14.736 16.2664 15.1606C16.0905 15.5852 16 16.0404 16 16.5Z"
      stroke="#85C440"
      strokeWidth="0.8"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>,
  'TotalAvailable',
);

export default TotalAvailable;
